function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState } from 'react';
import { usePrefixCls } from '@byte-design/config';
import { useRefCallback, useRefGetter } from '@bydesign-ui/hooks';
import { classnames, pick } from '@bydesign-ui/utils';
import { Down, Minus, Plus, Up } from '../../common/icons';
import { AxisType, useDownStep, usePrecisionValue, useUpStep } from '../../hooks/region';
import { INPUT_COMMON_ATTRS } from '../../units/input-wrapper/const';

function preventDefault(e) {
  e.preventDefault();
}

export function InputNumberContent(props) {
  var className = props.className,
      style = props.style,
      inputRef = props.inputRef,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      value = props.value,
      precision = props.precision,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$needGrouped = props.needGrouped,
      needGrouped = _props$needGrouped === void 0 ? true : _props$needGrouped,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$hideButton = props.hideButton,
      hideButton = _props$hideButton === void 0 ? false : _props$hideButton,
      format = props.format,
      parse = props.parse,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type,
      _props$filled = props.filled,
      filled = _props$filled === void 0 ? false : _props$filled,
      extra = _objectWithoutProperties(props, ["className", "style", "inputRef", "invalid", "value", "precision", "disabled", "needGrouped", "size", "hideButton", "format", "parse", "onFocus", "onBlur", "type", "filled"]);

  var _usePrecisionValue = usePrecisionValue('end', AxisType.HORIZONTAL, format, parse, value, precision),
      _usePrecisionValue2 = _slicedToArray(_usePrecisionValue, 3),
      inputValue = _usePrecisionValue2[0],
      setInputValue = _usePrecisionValue2[1],
      checkInputValid = _usePrecisionValue2[2];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useUpStep = useUpStep('end', AxisType.HORIZONTAL, false),
      _useUpStep2 = _slicedToArray(_useUpStep, 2),
      disabledUp = _useUpStep2[0],
      handleUp = _useUpStep2[1];

  var _useDownStep = useDownStep('end', AxisType.HORIZONTAL, false),
      _useDownStep2 = _slicedToArray(_useDownStep, 2),
      disabledDown = _useDownStep2[0],
      handleDown = _useDownStep2[1];

  var disabledGetter = useRefGetter(disabled);
  var onBlurCallback = useRefCallback(onBlur);
  var onFocusCallback = useRefCallback(onFocus);
  var onUpClick = useCallback(function () {
    if (disabledGetter()) {
      return;
    }

    handleUp();
  }, []);
  var onDownClick = useCallback(function () {
    if (disabledGetter()) {
      return;
    }

    handleDown();
  }, []);
  var onKeyDown = useCallback(function (e) {
    if (disabledGetter()) {
      return;
    }

    if (e.keyCode === 38) {
      handleUp();
    } else if (e.keyCode === 40) {
      handleDown();
    }
  }, []);
  var onInputFocus = useCallback(function (e) {
    setFocus(true);
    onFocusCallback(e);
  }, []);
  var onInputBlur = useCallback(function (e) {
    checkInputValid();
    setFocus(false);
    onBlurCallback(e);
  }, []);
  var onInput = useCallback(function (e) {
    return setInputValue(e.target.value);
  }, []);
  var grouped = usePrefixCls('can-input-grouped', {
    focus: focus
  });
  var cls = classnames(usePrefixCls('input-number', {
    size: size,
    focus: focus,
    disabled: disabled,
    warning: invalid && !disabled,
    filled: filled
  }), needGrouped ? grouped : '', className);
  var inputCls = usePrefixCls('input-number-input', {
    'left-right': type === 'left-right'
  });
  var leftRightCls = usePrefixCls('input-number-left-right-label');
  var controlsCls = usePrefixCls('input-number-controls', {
    hide: hideButton
  });
  var upBtn = usePrefixCls('input-number-controls-btn', {
    up: true,
    disabled: disabledUp
  });
  var downBtn = usePrefixCls('input-number-controls-btn', {
    down: true,
    disabled: disabledDown
  });

  var _pick = pick(extra, INPUT_COMMON_ATTRS),
      _pick2 = _slicedToArray(_pick, 2),
      inputPops = _pick2[0],
      divProps = _pick2[1];

  return React.createElement("div", Object.assign({
    className: cls,
    style: style
  }, divProps, {
    onKeyDown: onKeyDown
  }), React.createElement("input", Object.assign({}, inputPops, {
    ref: inputRef,
    type: "text",
    className: inputCls,
    disabled: disabled,
    value: inputValue,
    onBlur: onInputBlur,
    onFocus: onInputFocus,
    onChange: onInput
  })), type === 'left-right' ? React.createElement("div", {
    className: leftRightCls
  }, React.createElement("span", {
    className: upBtn,
    onClick: onUpClick,
    onMouseDown: preventDefault
  }, React.createElement(Plus, null)), React.createElement("span", {
    className: downBtn,
    onClick: onDownClick,
    onMouseDown: preventDefault
  }, React.createElement(Minus, null))) : React.createElement("div", {
    className: controlsCls
  }, React.createElement("span", {
    className: upBtn,
    onClick: onUpClick,
    onMouseDown: preventDefault
  }, React.createElement(Up, null)), React.createElement("span", {
    className: downBtn,
    onClick: onDownClick,
    onMouseDown: preventDefault
  }, React.createElement(Down, null))));
}